export default __webpack_public_path__ + "static/media/apollo_2.8bd0ca44.jpg";